module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "sitePreConfig-container"
    }
  }, [_c('table', {
    staticClass: "siteConfigTable"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.siteInfoArray.length), function(n) {
    return _c('tr', [_c('td', {
      staticClass: "content"
    }, [_vm._v(_vm._s(_vm.siteInfoArray[n - 1].oriSiteName.replace(/\+/g, '、')))]), _vm._v(" "), _c('td', {
      staticClass: "content"
    }, [_c('el-select', {
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "placeholder": "如未选择将保留原场地信息",
        "multiple": "",
        "filterable": "",
        "clearable": ""
      },
      on: {
        "change": _vm.handleSiteChange
      },
      model: {
        value: (_vm.siteInfoArray[n - 1].newSiteCode),
        callback: function($$v) {
          _vm.$set(_vm.siteInfoArray[n - 1], "newSiteCode", $$v)
        },
        expression: "siteInfoArray[n-1].newSiteCode"
      }
    }, _vm._l((_vm.comboOption.site[n - 1]), function(item, index) {
      return _c('el-option', {
        key: item.comboValue,
        attrs: {
          "value": item.comboValue,
          "label": item.comboName + '（' + item.capacity + '人）'
        }
      })
    }), 1)], 1)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "title",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("当前场地")]), _vm._v(" "), _c('td', {
    staticClass: "title",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("指定场地")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f72e2da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/timetableManage/arrange/sitePreConfig.vue
// module id = 1802
// module chunks = 502